module.exports = __webpack_public_path__ + "static/media/check.efe7d911.png";